import { HttpResponse, iDeliveryLocation } from "../types";
import HttpClientRequest from "../api/client-request";

export default class ShippingService {

    static async createShippingAddress(payload: iDeliveryLocation, requestId?: string): Promise<HttpResponse> {
        let response;
        try {
            
            response = await HttpClientRequest.doPostRequest('/shipping/location-book', payload, {
                'Content-Type': 'application/json'
            }, requestId);

            return response;

        } catch (error) {
            requestId && HttpClientRequest.cancelRequest(requestId);
            console.error("Error fetching products:", error);
            return {
                status: 503,
                data: [],
                message: (error as Error).message,
                isCanceled: true,
            };
        }
    }
    
    static async getShippingAddress(userId: number, requestId?: string): Promise<HttpResponse> {
        let response;
        try {
            
            response = await HttpClientRequest.doGetRequest(`/shipping/location-book/${userId}`, {}, requestId);

            return response;

        } catch (error) {
            requestId && HttpClientRequest.cancelRequest(requestId);
            console.error("Error fetching products:", error);
            return {
                status: 503,
                data: [],
                message: (error as Error).message,
                isCanceled: true,
            };
        }
    }

    static async updateShippingAddress(payload: iDeliveryLocation, requestId?: string): Promise<HttpResponse> {
        let response;
        try {
            
            response = await HttpClientRequest.doPutRequest(`/shipping/location-book/${payload.id}`, payload, {
                'Content-Type': 'application/json'
            }, requestId);

            return response;

        } catch (error) {
            requestId && HttpClientRequest.cancelRequest(requestId);
            console.error("Error fetching products:", error);
            return {
                status: 503,
                data: [],
                message: (error as Error).message,
                isCanceled: true,
            };
        }
    }

    static async deleteShippingAddress(shippingLocationBookId: Number, requestId?: string): Promise<HttpResponse> {
        let response;
        try {
            
            response = await HttpClientRequest.doDeleteRequest(`/shipping/location-book/${shippingLocationBookId}`, {}, requestId);

            return response;

        } catch (error) {
            requestId && HttpClientRequest.cancelRequest(requestId);
            console.error("Error fetching products:", error);
            return {
                status: 503,
                data: [],
                message: (error as Error).message,
                isCanceled: true,
            };
        }
    }
}